module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch1_20210921071149_T.0d2cf9a4.jpg";